<template>
  <b-card>
    <b-card-header>
      <h2>Past Causes</h2>
    </b-card-header>
    <b-card-body>
      <p>
        None yet, but check out our featured causes!
      </p>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  name: 'PastCause',
  data () {
    return {
    }
  }
}</script>
<style scoped>

  p, h2, h3 {
    width: 85%;
    text-align: left;
  }

</style>
